export default __webpack_public_path__ + "a3d2e4431d6888eb385827f0be7fc15f.obj";